import { render, staticRenderFns } from "./SetDialog.vue?vue&type=template&id=0d66ca60"
import script from "./SetDialog.vue?vue&type=script&lang=js"
export * from "./SetDialog.vue?vue&type=script&lang=js"
import style0 from "./SetDialog.vue?vue&type=style&index=0&id=0d66ca60&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports